<div class="d-flex justify-content-end px-4 pt-3">
  <app-button id="back-desktop" [onlyIcon]="true" [isIcon]="true" [left]="true" [iconName]="'bi bi-arrow-left'"
    [buttonOptions]="backOptions" (buttonClick)="back()">
  </app-button>
</div>

<div [innerHTML]="privacyPolicy" class="pb-5" style=" text-align: justify"></div>
